// 2026-10-11 E4 (cierre, split del entry): buffer tiny sin dependencias para
// los errores del primer paint. Lo usan instrumentation-client.ts (lo instala
// en module scope, sin tocar el SDK) y el host diferido SentryLazyInit (lo
// drena tras el init). También guarda el hook de transiciones del router.
type RouterHook = (href: string, navigationType: string) => void;

const earlyBuffer: Array<unknown> = [];
let routerHook: RouterHook | null = null;

function pushEarly(error: unknown): void {
  if (earlyBuffer.length < 20) earlyBuffer.push(error);
}

function onEarlyError(event: globalThis.ErrorEvent): void {
  pushEarly(
    (event as globalThis.ErrorEvent & { error?: unknown }).error ??
      event.message,
  );
}

function onEarlyRejection(event: PromiseRejectionEvent): void {
  pushEarly(event.reason);
}

/** Instala los hooks (llamar una vez en module scope del cliente). */
export function installEarlyErrorHooks(): void {
  if (typeof window === "undefined") return;
  window.addEventListener("error", onEarlyError);
  window.addEventListener("unhandledrejection", onEarlyRejection);
}

/** Suelta los hooks (tras el init o si el SDK falla). */
export function releaseEarlyErrorHooks(): void {
  if (typeof window === "undefined") return;
  window.removeEventListener("error", onEarlyError);
  window.removeEventListener("unhandledrejection", onEarlyRejection);
}

/** Vacía el buffer (el consumidor reporta cada error a su manera). */
export function drainEarlyErrors(): Array<unknown> {
  return earlyBuffer.splice(0);
}

export function setRouterHook(hook: RouterHook | null): void {
  routerHook = hook;
}

export function getRouterHook(): RouterHook | null {
  return routerHook;
}
